import { render, staticRenderFns } from "./Huotui.vue?vue&type=template&id=c73197e6&scoped=true&"
import script from "./Huotui.vue?vue&type=script&lang=js&"
export * from "./Huotui.vue?vue&type=script&lang=js&"
import style0 from "./Huotui.vue?vue&type=style&index=0&id=c73197e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73197e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
